<template lang="pug">
.locator
  .locator__header
    h2.locator__header-title Branch Locations & Services
    //- input.locator__header-search(v-model="searchText", placeholder="Search by address, city or zip code" v-on:keyup.enter="search")
    .locator__header-actions
      button.locator__header-geolocation(@click="findLocation", type="button") Use my Location
      a.locator__header-atm(:href="config.findAnAtmUrl") Find a Free ATM

  .locator__filters
    select.locator__filters-sortBy(v-model="sortBy", @change="sortByChanged", :class="{ 'dimmed': sortBy === '' }")
      option(disabled, value="") Search by Area
      option(v-for="item in config.sortFields") {{ item }}
  .locator__content
    .locator__content-sidebar#scrolling-list(ref="list")
      .branch(v-for="(item, i) in locations",
        :id="`branch_${i}`",
        :class="{ 'active': active_location && active_location.name === item.name }"
        @mouseenter="highlightMarker(i)")
        .branch__item
          h5.branch__name {{ item.Name }}
          a.branch__alert(v-if="item.AlertTitle", :href="item.BranchUrl")
            p {{ item.AlertTitle }}
            img(:src="settings.alertIcon")
          p.branch__addr1 {{ item.StreetAddress }}
          p.branch__addr2 {{ item.City }}, {{ item.State }} {{ item.PostalCode }}
          p.branch__distance(v-if="geolocation") {{ item.distanceFrom }} Miles away
          p.branch__atm {{ item.ATMHours }}

          .branch__hours(v-if="!item.LobbyClosed")
            button.branch__hours-message(@click="item.viewLobbyHours = !item.viewLobbyHours", :class="{ 'closed': getHoursMessage(item, 'Lobby').closed, 'open': item.viewLobbyHours }", type="button") {{ getHoursMessage(item, 'Lobby').message }}
            .branch__hours-details(:class="{ 'visible': item.viewLobbyHours }")
              span(v-for="day in item.LobbyHours.Days", :class="{ 'active': getIsToday(day) }")
                p {{ day.DayOfWeek }}
                p {{ getDayTimes(day) }}
          p.branch__message(v-else) {{ item.LobbyClosedMessage }}

          .branch__hours(v-if="!item.DriveThruClosed")
            button.branch__hours-message(@click="item.viewDriveThruHours = !item.viewDriveThruHours", :class="[{ 'closed': getHoursMessage(item, 'DriveThru').closed }, { 'open': item.viewDriveThruHours }]", type="button") {{ getHoursMessage(item, 'DriveThru').message }}
            .branch__hours-details(:class="{ 'visible': item.viewDriveThruHours }")
              span(v-for="day in item.DriveThruHours.Days", :class="{ 'active': getIsToday(day) }")
                p {{ day.DayOfWeek }}
                p {{ getDayTimes(day) }}
          p.branch__message(v-else) {{ item.DriveThruClosedMessage }}

          .branch__actions
            button(@click="getDirections(item)", type="button") Directions
            a(:href="item.BranchUrl") Branch Details
    .locator__content-map(ref="map")
</template>

<script>
import moment from 'moment';
import gmapsInit from "../utilities/gmaps";
import loader from "../components/loader";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ['settings'],
  data: () => ({
    sortBy: "",
    geolocation: false,
    scrollLock: false,
    google: null,
    active_location: null,
    map: null,
    map_options: {},
    station_marker: null,
    address_components: [],
    markers: [],
    selectedMarker: null,
    bounds: null,
    loading: false
  }),
  components: {
    loader
  },
  computed: {
    ...mapGetters(["locations", "options", "config"]),
  },
  methods: {
    formatPhone(el) {
      el = `(${[el.slice(0, 3), ') ', el.slice(3)].join('')}`;
      return [el.slice(0, 9), '-', el.slice(9)].join('');
    },
    getIsToday(el) {
      let day = moment(new Date()).format('dddd');
      return el.DayOfWeek === day;
    },
    getDayTimes(day) {
      if (day.Open) {
        return `${day.OpenTime} - ${day.CloseTime}`
      } {
        return 'Closed'
      }
    },
    getHoursMessage(el, type) {
      let format = 'hh:mm A'
      let day = moment(new Date()).format('dddd');
      let currentEl = el[`${type}Hours`].Days.find(el => el.DayOfWeek === day);
      let currentElIndex = el[`${type}Hours`].Days.findIndex(el => el.DayOfWeek === day);
      let firstOpenEl = el[`${type}Hours`].Days.find(el => el.Open);

      let message = null;
      let closed = true;
      let beforeTime = moment(currentEl.OpenTime, format);
      let afterTime = moment(currentEl.CloseTime, format);

      if (currentEl.Open && moment(new Date()).isBetween(beforeTime, afterTime)) {
        closed = false;
        message = `open today until ${currentEl.CloseTime}`
      } else if (currentEl.Open && moment(new Date()).isBefore(beforeTime)) {
        message = `closed until ${currentEl.DayOfWeek} at ${currentEl.OpenTime}`
      } else {
        el[`${type}Hours`].Days.forEach((el, i) => {
          if (message) return;
          if (i > currentElIndex) {
            if (el.Open) {
              message = `closed until ${el.DayOfWeek} at ${el.OpenTime}`;
            } else if (firstOpenEl) {
              message = `closed until ${firstOpenEl.DayOfWeek} at ${firstOpenEl.OpenTime}`
            }
            else {
              message = `closed until further notice`
            }
          }
        })
      }

      return {
        closed: closed,
        message: type === 'Lobby' ? `Lobby ${message}` : `Drive-thru ${message}`
      }
    },
    getDirections(el) {
      let link = document.createElement('a');
      let base = 'https://www.google.com/maps/dir/';
      let { StreetAddress, City, State, PostalCode, Latitude, Longitude } = el;
      StreetAddress = String(StreetAddress).trim().replace(/\s*?\(.*?\)\s*?/gmi, '');
      City = String(City).trim();
      State = String(State).trim();
      PostalCode = String(PostalCode).trim();
      Latitude = String(Latitude).trim();
      Longitude = String(Longitude).trim();

      let address = encodeURI(`United Heritage Credit Union,+${StreetAddress},+${City},+${State}+${PostalCode}`.replace(/\s+/gmi, '+'));
      let position = encodeURI(`@${Latitude},${Longitude}`);

      link.setAttribute('data-popup-trigger', '#popup_external');
      link.setAttribute('data-target', `${base}/${address}/${position}`);
      link.setAttribute('href', `${base}/${address}/${position}`);

      link.style.height = '0';
      link.style.width = '0';
      link.style.opacity = '0';
      link.style.position = 'absolute';
      link.style.overflow = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async findLocation() {
      navigator.geolocation.watchPosition(async (position) => {
        let geoLat = position.coords.latitude;
        let geoLng = position.coords.longitude;

        await this.locations.forEach((loc) => {
          loc['distanceFrom'] = this.getDistance(geoLat, geoLng, loc.Latitude, loc.Longitude, "K")
        })

        this.locations.sort((a, b) => (a.distanceFrom > b.distanceFrom) ? 1 : -1)


        this.geolocation = true;
      }, (error) => {
        if (error.code === error.PERMISSION_DENIED) {
        }
      })
    },
    getDistance(locLat, locLng, elLat, elLng, unit) {
      let radGeoLat = Math.PI * locLat / 180;
      let radLocLat = Math.PI * elLat / 180;

      let theta = locLng - elLng;
      let radTheta = Math.PI * theta / 180;

      let dist = Math.sin(radGeoLat) * Math.sin(radLocLat) + Math.cos(radGeoLat) * Math.cos(radLocLat) * Math.cos(radTheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;

      if (unit === "K") { dist = dist * 1.609344 }
      if (unit === "N") { dist = dist * 0.8684 }

      return Math.round(dist * 10) / 10
    },
    async sortByChanged() {

      this.locations.sort((a, b) => { return a.Region === this.sortBy ? -1 : b.Region === this.sortBy ? 1 : 0; });
      this.$refs.list.scrollTo({ behavior: 'smooth', top: 0 });
      if (this.locations) {
        blue.meth.cookie.set('LocationFilter', this.sortBy, '/', 90);
      }
      await this.reboundMap(this.locations[0].Region !== 'Tyler');
    },
    async dropMarkerPins() {
      this.bounds = new google.maps.LatLngBounds();

      this.address_components = this.locations.reduce(
        async (accu, location, i) => {
          const address_components = await accu;

          await new Promise((resolve) => {
            const marker = this.createMarker(location, i, false)
            if (marker.__meta.Region !== 'Tyler') {
              this.bounds.extend(marker.getPosition());
            }

            this.markers.push(marker);
            marker.addListener("click", (fromNav) => {
              if (this.selectedMarker) {
                this.selectedMarker.setIcon({
                  url: this.settings.pin,
                  scaledSize: new google.maps.Size(35, 35),
                });
              }

              marker.setIcon({
                url: this.settings.pin,
                scaledSize: new google.maps.Size(50, 50),
              });
              this.selectedMarker = marker;
              this.toggle_location(this.selectedMarker, fromNav === true ? fromNav : false);
              if (marker.__meta.Region !== 'Tyler') {
                this.reboundMap(true);
              } else {
                this.reboundMap(false);
              }
            });
            resolve(marker);
          });
          address_components.push(location);
          return address_components;
        },
        Promise.resolve([])
      );

      this.map.fitBounds(this.bounds); //auto-zoom
    },
    createMarker(el, index, useGeocode) {
      return new this.google.maps.Marker({
        map: this.map,
        id: index,
        icon: {
          url: this.settings.pin,
          scaledSize: new google.maps.Size(35, 35),
        },
        position: {
          lat: useGeocode ? el.geometry.location.lat() : parseFloat(el.Latitude),
          lng: useGeocode ? el.geometry.location.lng() : parseFloat(el.Longitude),
        },
        __meta: {
          id: index,
          ...el,
        }
      });
    },
    toggle_location(marker, fromNav) {
      this.active_location = marker.__meta;
      if (!fromNav) {
        if (!this.locations.length || !this.active_location) return;
        let index = this.locations.findIndex((el) => el.Name === this.active_location.Name)
        let myElement = document.getElementById(`branch_${index}`);
        let arr = [...document.getElementsByClassName('branch-focused')];

        arr.forEach((el) => {
          el.classList.remove('branch-focused')
        })

        myElement.classList.add('branch-focused');

        document.getElementById('scrolling-list').scrollTo({ top: (myElement.offsetHeight) * index, behavior: 'smooth' })
      }
    },
    highlightMarker(i) {
      let element = document.getElementById(`branch_${i}`);
      let arr = [...document.getElementsByClassName('branch-focused')];

      arr.forEach((el) => {
        el.classList.remove('branch-focused')
      })

      element.classList.add('branch-focused');
      this.google.maps.event.trigger(this.markers[i], 'click', true);
    },
    async reboundMap(showCentral) {

      //console.log("reboundMap...");

      this.bounds = new google.maps.LatLngBounds();
      this.markers.forEach((marker) => {
        let region = marker.__meta.Region;
        if (showCentral && region !== 'Tyler') {
          this.bounds.extend(marker.getPosition());
        } else if (!showCentral && region === 'Tyler') {
          this.bounds.extend(marker.getPosition());
          this.google.maps.event.addListenerOnce(this.map, 'bounds_changed', function (event) {
            this.setZoom(13);
          });
        }
      });

      this.map.fitBounds(this.bounds);
    },
    init() {
      return new Promise(async resolve => {

        var activeFilter = blue.meth.cookie.get('LocationFilter');
        if (activeFilter && activeFilter !== "") {
          this.sortBy = activeFilter;
          this.locations.sort((a, b) => { return a.Region === this.sortBy ? -1 : b.Region === this.sortBy ? 1 : 0; });
        }

        this.google = await gmapsInit(this.settings.googleApi);

        this.map_options = {
          mapTypeId: this.google.maps.MapTypeId.TERRAIN,
          clickableIcons: false,
          gestureHandling: "cooperative",
          disableDefaultUI: true,
          zoom: this.options.initialZoom,
          center: new this.google.maps.LatLng(
            this.options.center.lat,
            this.options.center.lng
          ),
        };

        this.map = new this.google.maps.Map(
          this.$refs.map,
          this.map_options
        );
        resolve();
      })
    },
  },
  async mounted() {
    await this.init();
    await this.dropMarkerPins();
    setTimeout(async () => {
      await this.reboundMap(true);
    }, 500);
  },
};




</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.locator {
  * {
    font-family: 'News Gothic', Sans-Serif, sans-serif;
  }

  &__header {
    min-height: 7rem;
    position: relative;
    margin-bottom: 1.5rem;
    z-index: 0;
    display: flex;

    @include mqdn(md) {
      flex-direction: column;

      .locator__header-title {
        text-align: center;
      }

      .locator__header-search {
        margin-left: 0;
      }

      .locator__header-actions {
        margin: 1rem 0;
      }

      .locator__header-geolocation {
        display: inline-block;
        width: 48%;
        margin-right: 0;
        padding-right: 0;
        border-right: 0;
      }

      .locator__header-atm {
        display: inline-block;
        width: 48%;
      }
    }

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      bottom: 0;
      top: 0;
      width: 100vw;
      background: $red;
      left: 50%;
      transform: translateX(-50%);
      background: #E3E9EC;
    }

    &-title {
      margin: auto 0;
      font-size: 2.3rem;
    }

    &-search {
      flex: 1;
      height: 2rem;
      margin: auto 1rem;
      border-color: #979797;
      border-width: 0 0 1px 0;
      font-size: 1.3rem;
      background: none;
    }

    &-actions {
      margin: auto 0 auto auto;
    }

    &-geolocation,
    &-atm {
      background: none;
      border: none;
      padding: 0;
      margin: auto 0;
      text-decoration: underline;
      color: #005580;
      height: 2rem;
      font-size: 1.1rem;
      cursor: pointer;

      &:hover {
        color: darken(#005580, 20%);
      }
    }

    &-geolocation {
      margin-right: 1.5rem;
      padding-right: 1.5rem;
      border-right: 1px solid #D8D8D8
    }
  }

  &__filters {
    margin-bottom: 1rem;
    display: flex;
    justify-content: flex-end;

    &-sortBy {
      padding: 1rem;
      border-color: #D8D8D8;
      border-radius: 6px;
      width: 13rem;
      height: 3.125rem;
      font-size: 1rem;

      @include mqdn(md) {
        width: 100%;
      }

      &.dimmed {
        color: lighten($black, 20%);
      }
    }
  }

  &__content {
    display: flex;
    height: 47rem;

    @include mqdn(md) {
      flex-direction: column-reverse;
      height: unset;
    }

    &-sidebar {
      flex: 0 0 20rem;
      overflow-y: auto;
      padding-right: 1rem;

      @include mqdn(md) {
        padding-right: 0;
        padding-top: 1rem;
        flex: unset;
      }
    }

    &-map {
      flex: 1;

      @include mqdn(md) {
        flex: 20rem;
      }
    }
  }

  .branch {
    &:last-of-type {
      .branch__item {
        border-bottom: 1px solid #D8D8D8;
      }
    }

    &-focused {
      transition: ease .25s;
      background: rgba(227, 233, 236, 0.25);
    }

    &__item {
      cursor: pointer;
      padding: 1rem;
      border-top: 1px solid #D8D8D8;
    }

    &__name {
      font-size: 1.25rem;
      color: #2B2E2F;
      font-weight: 700;
      margin: 0 0 .875rem 0;
    }

    &__alert {
      font-weight: 700;
      font-size: .875rem;
      display: inline-block;
      margin-right: auto;
      margin-bottom: .875rem;
      padding: .5rem;
      border: 1px solid $red;
      border-radius: .25rem;
      color: $red;

      p {
        height: 1rem;
        padding-right: .5rem;
        line-height: 1;
        display: inline-block;
        margin: 0;
      }

      img {
        color: $red;
        float: right;
        margin-top: 2px;
        height: .875rem;
      }
    }

    &__addr1,
    &__addr2,
    &__distance {
      line-height: 1.25rem;
      margin: 0;
    }

    &__atm {
      margin-bottom: 1.25rem;
    }

    &__copy {
      margin: .875rem 0;
    }

    &__message {
      font-size: 1rem;
      padding: 0 1rem 0 0;
      margin-bottom: .5rem;
      border: 0;
      color: $red;
    }

    &__hours {
      font-size: 0.875rem;
      text-align: left;

      &-message {
        cursor: pointer;
        color: #018528;
        padding: 0 1rem 0 0;
        margin: 0rem;
        border: 0;
        background: none;
        position: relative;

        &:after {
          content: '';
          top: 50%;
          right: 0;
          position: absolute;
          border: solid currentColor;
          border-width: 0 3px 3px 0;
          display: inline-block;
          padding: 3px;
          transition: ease .25s;
          transform: translateY(-80%) rotate(45deg);
        }

        &:hover {
          color: darken(#018528, 10%);
        }

        &.open:after {
          transform: translateY(-40%) rotate(-135deg);
        }

        &.closed {
          color: $red;

          &:hover {
            color: darken($red, 10%);
          }
        }
      }

      &-details {
        max-height: 0;
        overflow: hidden;
        transition: 0.25s ease;
        margin: 0 0 0.25rem;

        span {
          display: flex;

          &.active p {
            font-weight: 700;
          }

          p {
            margin: 0;
            flex: 1;
          }
        }

        &.visible {
          max-height: 200px;
          margin: 0 0 0.5rem;
        }
      }
    }

    &__actions {
      margin-top: 0.5rem;

      button,
      a {
        cursor: pointer;
        background: none;
        border: none;
        text-decoration: underline;
        color: #005580;
        padding: 0;
        font-size: 0.875rem;
      }

      button {
        margin-right: 0.75rem;
        padding-right: 0.75rem;
        border-right: 1px solid #D8D8D8;
      }
    }
  }
}
</style>
